import React from "react";
import { FiCheckCircle, FiClock, FiMail, FiMapPin, FiPhone } from "react-icons/fi";
import ContactForm from "../../components/public/ContactForm";
import "./Contato.css";

export default function Contato() {
  return (
    <div className="contact-page">
      <section className="contact-hero">
        <div className="contact-shell contact-hero__grid">
          <div>
            <p className="contact-kicker"><span /> Fale com a Hadritech</p>
            <h1>Vamos conversar sobre o seu próximo projeto?</h1>
            <p className="contact-hero__lead">
              Entre em contato para conhecer nossas soluções, solicitar uma demonstração ou conversar sobre consultoria especializada em Protheus RH.
            </p>
            <div className="contact-trust">
              <span><FiCheckCircle aria-hidden="true" /> Atendimento humano</span>
              <span><FiCheckCircle aria-hidden="true" /> Ambientes independentes</span>
            </div>
          </div>
          <aside className="contact-hero__card" aria-label="Canais de contato">
            <p className="contact-kicker contact-kicker--light">Canais diretos</p>
            <a href="mailto:contato@hadritech.com.br"><FiMail aria-hidden="true" /> contato@hadritech.com.br</a>
            <a href="tel:+5511954938127"><FiPhone aria-hidden="true" /> (11) 95493-8127</a>
            <p><FiClock aria-hidden="true" /> Segunda a sexta, 07:00 às 21:00</p>
            <p><FiMapPin aria-hidden="true" /> Atendimento remoto em todo o Brasil</p>
          </aside>
        </div>
      </section>
      <section className="contact-content">
        <div className="contact-shell contact-content__grid">
          <div className="contact-copy">
            <p className="contact-kicker">Conte o que você precisa</p>
            <h2>Um próximo passo claro começa com uma boa conversa.</h2>
            <p>Envie os detalhes do seu projeto. Nossa equipe retorna pelos canais informados, sem compromisso.</p>
          </div>
          <ContactForm />
        </div>
      </section>
    </div>
  );
}
